import { apiFetch, refreshSession, tokenStore } from '@/lib/api'
import type { AuthService } from '@/services/contracts'
import type { AuthenticatedUser, LoginResponse, UserSession } from '@/types/models'

/** Backend `SessionRead` — sözleşmede yok, `GET /users/me/sessions` gövdesi. */
export interface SessionReadDto {
  id: string
  issued_at: string
  expires_at: string
  user_agent: string | null
  ip: string | null
}

export function toUserSession(dto: SessionReadDto): UserSession {
  return {
    id: dto.id,
    created_at: dto.issued_at,
    // Backend bu bilgiyi tutmuyor; hiçbir ekran şu an bu alanı okumuyor.
    last_used_at: null,
    ip: dto.ip,
    user_agent: dto.user_agent,
    current: false,
  }
}

export const httpAuthService: AuthService = {
  async login({ email, password }) {
    const response = await apiFetch<LoginResponse>('/auth/login', {
      method: 'POST',
      body: { email, password },
      skipAuthRefresh: true,
    })
    tokenStore.set(response.access_token)
    return response
  },

  async refresh() {
    // `refreshSession` 401 yolundaki yenilemeyle tek kuyrukta çalışır; ayrı bir istek aynı
    // cookie'yi ikinci kez gönderip oturumu "yeniden kullanım" diye düşürüyordu.
    return refreshSession()
  },

  async logout() {
    try {
      await apiFetch<void>('/auth/logout', { method: 'POST', skipAuthRefresh: true })
    } catch {
      // Token zaten geçersizse sunucu tarafı önemli değil; yerel oturum yine de temizlenir.
    } finally {
      tokenStore.clear()
    }
  },

  async me(options) {
    return apiFetch<AuthenticatedUser>('/auth/me', { skipAuthRefresh: options?.skipAuthRefresh })
  },

  async changePassword(request) {
    await apiFetch<void>('/auth/change-password', { method: 'POST', body: request })
  },

  async listSessions() {
    const sessions = await apiFetch<SessionReadDto[]>('/users/me/sessions')
    return sessions.map(toUserSession)
  },

  async revokeSession(sessionId) {
    await apiFetch<void>(`/users/me/sessions/${sessionId}`, { method: 'DELETE' })
  },
}
